import axios, { AxiosError } from "axios";
import { IAxiosReturn, ISetting } from "../interface";
import { processAxiosError } from "../processAxiosError";

/**
 * Return for current maintenance mode
 *
 * @param maintenanceMode - whether maintenance mode is currently active
 * @param maintenanceMessage - associated message when in maintenance mode
 */
export interface MaintenanceModeReturn {
  maintenanceMode: boolean;
  maintenanceMessage?: string;
}

export type IMaintenanceReturn = IAxiosReturn<MaintenanceModeReturn>;

/**
 * Load the application's maintenance mode setting.
 *
 * @param backEndUrl - Base backend URL
 * @param _ - Unused placeholder
 * @param controller - Optional AbortController
 * @returns Current maintenance mode and message wrapped in IMaintenanceReturn
 */
export const loadMaintenanceMode = async (
  backEndUrl: string,
  _?: string,
  controller?: AbortController,
): Promise<IMaintenanceReturn> => {
  // Get data
  try {
    const response: { data: ISetting } = await axios.get(
      `${backEndUrl}Settings/MaintenanceMode`,
      controller
        ? {
            signal: controller.signal,
          }
        : undefined,
    );
    // Return successful result
    return {
      success: true,
      data: {
        maintenanceMode: response.data.value !== "",
        maintenanceMessage: response.data.value,
      },
    };
  } catch (error: unknown) {
    // Handle if no setting exists yet
    if ((error as AxiosError).response?.status === 404) {
      return {
        success: true,
        data: {
          maintenanceMode: false,
        },
      };
    }
    return processAxiosError("Load Maintenance Mode failed", error);
  }
};
